var wait = function (duration) { return new Promise(function (res) { return setTimeout(res, duration); }); };

export { wait };
//# sourceMappingURL=wait.esm.js.map
